import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../store/conventional';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private store?: Store<State>;
  private injector = inject(Injector);
  // private chunkFailedBrowserMessages = [
  //   'dynamically imported module',
  //   'failed to load module script',
  // ];

  handleError(error: Error): void {
    console.error(error);
    if (!this.store) { this.store = this.injector.get(Store<State>); }
    //const chunkFailedMessage = 'Failed to fetch dynamically imported module:';
    // if (error.message.includes(chunkFailedMessage)) {
    //   this.store.dispatch(logoutConfirmed());
    // }
  }
}